
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.679 7.702l-3.191 3.19a4.51 4.51 0 01-6.38 0 4.508 4.508 0 01-.686-.91L6.905 8.5c.07-.071.157-.112.24-.16.103.35.282.682.557.957.88.88 2.311.88 3.19 0l3.19-3.19a2.255 2.255 0 10-3.19-3.19L9.758 4.052A5.66 5.66 0 006.88 3.74l2.417-2.417a4.513 4.513 0 016.382 6.38zm-8.437 5.246l-1.135 1.136a2.26 2.26 0 01-3.19 0 2.26 2.26 0 010-3.191l3.19-3.19c.88-.88 2.31-.88 3.19 0 .275.274.454.606.558.956.084-.049.17-.088.24-.159l1.483-1.482a4.434 4.434 0 00-.686-.91 4.512 4.512 0 00-6.38 0l-3.19 3.19a4.513 4.513 0 006.38 6.38l2.418-2.417a5.657 5.657 0 01-2.878-.313z"}})])
          )
        }
      }
    